export const bannerListItemStyle = theme => ({

	bannerItemContainer: {
		color: theme.variables.colors.bannerColor,
		backgroundImage: `linear-gradient(7deg, ${theme.variables.colors.bannerBgColor} 20%, ${theme.variables.colors.bannerGrdColor} 125%)`,
		backgroundPositionX: theme.variables.topBannerPositionX,
		backgroundPositionY: theme.variables.topBannerPositionY,
		backgroundColor: theme.variables.colors.bannerBgColor,
		backgroundSize: theme.variables.topBannerBgImgSize,
		minHeight: `calc(${theme.variables.topBannerMHC} * 3)`,
		'@media screen and (max-width: 2000px)': {
		  minHeight: `calc(${theme.variables.topBannerMHC} * 2.725)`,
		},
		'@media screen and (max-width: 1800px)': {
		  minHeight: `calc(${theme.variables.topBannerMHC} * 2.35)`,
		},
		'@media screen and (max-width: 1600px)': {
		  minHeight: `calc(${theme.variables.topBannerMHC} * 2)`,
		},
		'@media screen and (max-width: 1400px)': {
		  minHeight: `calc(${theme.variables.topBannerMHC} * 1.75)`,
		},
		'@media screen and (max-width: 1200px)': {
		  minHeight: `calc(${theme.variables.topBannerMHC} * 1.5)`,
		},
		'@media screen and (max-width: 599.98px)': {
     	backgroundPositionX: theme.variables.topBannerPositionSmallX,
  		backgroundPositionY: theme.variables.topBannerPositionSmallY,
		  backgroundSize: theme.variables.topBannerBgImgSmallSize,
		  minHeight: theme.variables.topBannerMHC,
		},
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		alignItems: 'center',
		paddingTop: '0px',
		paddingBottom: '0px',
		'& h1,& h2,& h3,& h4,& h5,& h6,& a,& p': {
			lineHeight: '1.3',
		},
	},
	fullHeight: {
	   height: '100%',
	},
	bannerItemTitle: {
		fontSize: '34px',
		color: theme.variables.colors.bannerTitleColor,
		borderRadius: theme.variables.borderRadius,
		backgroundColor: theme.variables.topBannerTitleBgColor,
		paddingLeft: '0',
    paddingRight: '.5rem',
		'@media screen and (max-width: 1200px)': {
			fontSize: '30px',
		},
		'@media screen and (max-width: 1024px)': {
			fontSize: '22px',
		},
	  '@media screen and (max-width: 992px)': {
		  maxWidth: '60%',
		},
		'@media screen and (max-width: 768px)': {
		  maxWidth: '60%',
		},
		'@media screen and (max-width: 576px)': {
		  fontSize: '20px',
		  maxWidth: '50%',
		},
		'@media screen and (max-width: 479.98px)': {
		  fontSize: '14px',
		  maxWidth: '65%',
		},
	},
	bannerItemDescription: {
		fontSize: '20px',
		'@media screen and (max-width: 1200px)': {
			fontSize: '18px',
		},
		'@media screen and (max-width: 1024px)': {
			fontSize: '16px',
		},
		'@media screen and (max-width: 480px)': {
		  fontSize: '13px',
		},
	},
	bannerItemContent: {
		display: 'flex',
		borderRadius: '50%',
		overflow: 'hidden',
		color: theme.variables.colors.bannerRoundColor,
		width: '200px',
		height: '200px',
		textAlign: 'center',
		background: `${theme.variables.colors.bannerBgRoundColor} center/contain`,
		marginRight: '5%',
		marginLeft: 'calc(5% + 10px)',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		'& p,& h1,& h2,& h3,& h4,& h6,& a,& i': {
			color: theme.variables.colors.bannerRoundColor,
			lineHeight: '0.1em',
		},
		'@media screen and (max-width: 1200px)': {
			height: '150px',
			width: '150px',
		},
		'@media screen and (max-width: 992px)': {
			display: 'none',
		},
	},
	bannerItemFull: {
		maxWidth: '570px',
		alignItems: 'start',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '0 30px !important',
		'@media screen and (max-width: 1200px)': {
			maxWidth: '470px',
		},
		'@media screen and (max-width: 1024px)': {
			maxWidth: '400px',
		},
		'@media screen and (max-width: 992px)': {
			maxWidth: '100%',
			minWidth: '100%',
			padding: '0 20px !important',
		},
		'@media screen and (max-width: 479.98px)': {
		  padding: '0 !important',
		},
	},
	bannerItemRatio: {
	    position: 'relative',
      width: '100%',
      paddingTop: `${theme.variables.topBannerAspectRatioPersent}%`,
      //'@media screen and (max-width: 992px)': {
      //  paddingTop: `${theme.variables.topBannerAspectRatioPersent * 2}%`,
      //},
      //'@media screen and (max-width: 480px)': {
      //  paddingTop: `${theme.variables.topBannerAspectRatioPersent * 2.5}%`,
      //},
	    '& > *': {
	       position: 'absolute',
         top: 0,
         left: 0,
         width: '100%',
         height: '100%',
	    },
	 },
})
